import React from 'react';
import '../App.css'
const Footer = () => {
    return (
        <div className='w-full h-[170px] bg-white px-[4vw] flex flex-row-col items-center relative justify-between-center' style={{zIndex:2}}>
            <div className='text-[#614E33] font-bold text-[24px]'>港才薈 TGather</div>
            <div className='text-[#614E33] foot-copy-text'>
                    © 2024 Aquila Technology International Ltd. All right reserved.<br/>
                    粤ICP备2025481787号-1<br/>
                    版权所有：香江人才发展（广州）有限公司
            </div>
        </div>
    );
};

export default Footer